<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            Email Templates
            <v-spacer></v-spacer>
            <v-btn color="primary" tile outlined to="/admin/tracker/email-template/new">
              <v-icon left>fas fa-plus</v-icon>
              Add Template
            </v-btn>
          </v-card-title>
          <v-card-text>
            <span>This is where you can view, edit, and remove email templates.</span>
            <v-text-field v-model="search" label="Template Filter" append-icon="fal fa-search"></v-text-field>
            <v-data-table :items="templates" :headers="headers" :server-items-length="templateCount" @update:options="loadTemplates">
              <template v-slot:item.body="{ item }">
                <div v-html="item.body" style='max-width:300px;max-height:80px;overflow:hidden;'></div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon :to="'/admin/tracker/email-template/'+item._id">
                  <v-icon>fal fa-pencil</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { ref, watch, onMounted } from '@vue/composition-api'
export default {
  setup (props, { root }) {
    const search = ref('')
    const templates = ref([])
    const headers = ref([
      { text: 'Title', value: 'title' },
      { text: 'Subject', value: 'subject' },
      { text: 'From', value: 'from' },
      { text: 'Email', value: 'body' },
      { text: 'Actions', value: 'actions' }
    ])
    const templateCount = ref(0)
    const loading = ref(false)

    function loadTemplates (options) {
      loading.value = true
      let query = {
        module: 'Orientation'
      }
      if (options != null) {
        const { sortBy, descending, page, itemsPerPage } = options
        query = {
          $limit: itemsPerPage,
          $skip: (page - 1) * itemsPerPage,
          $sort: {}
        }
        for (let i = 0; i < sortBy.length; i++) {
          query.$sort[sortBy[i]] = descending[i] ? 1 : -1
        }
        if (sortBy.length === 0) query.$sort.title = 1
      }
      if (search.value !== '') {
        query.$or = [
          { title: { $regex: search.value, $options: 'i' } },
          { subject: { $regex: search.value, $options: 'i' } },
          { body: { $regex: search.value, $options: 'i' } }
        ]
      }
      root.$feathers.service('system/email-template').find({ query }).then(({ total, data }) => {
        templateCount.value = total
        templates.value = data
        loading.value = false
      })
    }
    watch(search, () => { loadTemplates() })
    // loadTemplates()
    onMounted(() => {
      if (!root.$store.getters.hasRole('Employee')) {
        root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have access to the admin system.' })
        root.$router.push('/')
      } else if (!root.$store.getters.isAdmin) {
        root.$store.dispatch('snackbar', { active: true, color: 'error', timeout: 6000, text: 'You do not have access to the email templates.' })
        root.$router.push('/admin')
      }
    })

    return {
      search,
      templates,
      headers,
      templateCount,
      loading,
      loadTemplates
    }
  }
}
</script>
